import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import {initializeTranslationProvider} from "./services/translationProvider";

// followed this https://dev.to/adrai/how-to-properly-internationalize-a-react-application-using-i18next-3hdb

i18n
  // i18next-http-backend
  // loads translations from your server
  // https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init(
    {
      debug: false,
      fallbackLng: "en",
      ns: [
        "translation",
        "event",
        "eventTemplate",
        "notice",
        "residentadmin",
        "saresidentadmin",
        "toastMessage",
        "specialDays",
        "villageCalendars"
      ],
      lng: "en", //default to nz
      backend: {
        // for all available options read the backend's repository readme file
        loadPath: "/locales/{{lng}}/{{ns}}.json",
        requestOptions: {
          cache: "reload"
        }
      },
      interpolation: {
        escapeValue: false // not needed for react as it escapes by default
      }
    },
    (error, t) => {
      initializeTranslationProvider(t);
    }
  );

export default i18n;
